// Mapper: transport LC_GetMyTeamMonthlyAbsenceSummaryOut → domain model for the
// "Mi equipo" dashboard "Resumen del mes" — "Ausencias" card (ASIS-5411 / REXASIS-010).
// The backend only sends the raw days + the cutoff's date range; the percentage/isEmpty
// business rules are computed here so the UI never re-implements them.
//
// totalDays (calculated absence days, caHistoricoLibroAsistenciaDet) and approvedDays
// (retroactively justified, caAusenciasInjustificadas) come from different subsystems, so
// approved <= total is not guaranteed — the backend already clamps pendingDays to 0 for the
// same reason. percentage is clamped to 100 here to match, and isEmpty requires both to be 0
// so a mismatch (e.g. total=0 with approved>0) never renders as the empty state.

import type {
  LC_GetMyTeamMonthlyAbsenceSummaryOut,
  MyTeamMonthlyAbsenceSummary,
} from '../types/myTeamMonthlyAbsenceSummary.types';


export function mapMyTeamMonthlyAbsenceSummary(
  out: LC_GetMyTeamMonthlyAbsenceSummaryOut,
): MyTeamMonthlyAbsenceSummary {
  const isEmpty = out.totalDays === 0 && out.approvedDays === 0;
  const percentage = isEmpty
    ? 0
    : Math.min(100, Math.round((out.approvedDays / out.totalDays) * 100));

  return {
    totalDays: out.totalDays,
    approvedDays: out.approvedDays,
    pendingDays: out.pendingDays,
    dateFrom: out.dateFrom,
    dateTo: out.dateTo,
    percentage,
    isEmpty,
  };
}
